'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _littleLoader = require('little-loader');

var _littleLoader2 = _interopRequireDefault(_littleLoader);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _themeProvider = require('@spp/theme-provider');

var _FacebookComments = require('./FacebookComments');

var _FacebookComments2 = _interopRequireDefault(_FacebookComments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, FB */

var countdownId = void 0;

var FbComments = function (_Component) {
    _inherits(FbComments, _Component);

    function FbComments() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FbComments);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FbComments.__proto__ || Object.getPrototypeOf(FbComments)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            commentsLoaded: false,
            hasFetchedServerTime: false,
            minutesUntilClose: 0
        }, _this.getRecurringServerTime = function (interval) {
            clearInterval(_this.getServerTime);
            setInterval(_this.getServerTime, interval);
        }, _this.getServerTime = function () {
            (0, _isomorphicFetch2.default)(_this.props.serverTimeEndpoint).then(function (res) {
                var _this$props = _this.props,
                    commentsOpenHour = _this$props.commentsOpenHour,
                    commentsCloseHour = _this$props.commentsCloseHour;

                var now = (0, _momentTimezone2.default)(res.headers.get('Date')).tz('Europe/Oslo');

                var startTime = (0, _momentTimezone2.default)(commentsOpenHour + ':00', 'HH:mm');
                var endTime = (0, _momentTimezone2.default)(commentsCloseHour + ':00', 'HH:mm');

                if (!now.isBetween(startTime, endTime)) {
                    _this.setState({
                        hasFetchedServerTime: true
                    });
                    return;
                }

                var minutesUntilClose = endTime.diff(now, 'minutes') + 1;

                _this.setState({
                    minutesUntilClose: minutesUntilClose,
                    hasFetchedServerTime: true
                });

                var shouldStartCountDown = minutesUntilClose < _this.props.minutesLeftWhenWarningDisplayed && !countdownId;
                if (!shouldStartCountDown) {
                    return;
                }

                countdownId = setInterval(_this.countdownMinutes, 60 * 1000); // ms
            });
        }, _this.countdownMinutes = function () {
            var minutesUntilClose = _this.state.minutesUntilClose;

            var minutesRemaining = minutesUntilClose - 1;
            _this.setState({ minutesUntilClose: minutesRemaining });
            if (minutesRemaining <= 0) {
                clearInterval(countdownId);
            }
        }, _this.loadFbSdk = function (lang) {
            if (!_this.props.commentsAlwaysOpen) {
                _this.getRecurringServerTime(_this.props.pollServerTimeInterval);
            }
            (0, _littleLoader2.default)('//connect.facebook.net/' + lang + '/sdk.js', function (err) {
                if (err) {
                    console.error(err);
                }
                _this.setState({ commentsLoaded: true });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FbComments, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            window.fbAsyncInit = function () {
                FB.init({
                    appId: _this2.props.appId,
                    cookie: _this2.props.cookie,
                    xfbml: _this2.props.xfbml,
                    version: _this2.props.version
                });
            };

            if (!this.props.commentsAlwaysOpen) {
                this.getServerTime();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                buttonText = _props.buttonText,
                commentsClosedHeading = _props.commentsClosedHeading,
                commentsClosedText = _props.commentsClosedText,
                commentsAlwaysOpen = _props.commentsAlwaysOpen,
                minutesLeftWhenWarningDisplayed = _props.minutesLeftWhenWarningDisplayed,
                url = _props.url,
                numPosts = _props.numPosts,
                theme = _props.theme,
                widgetWidth = _props.widgetWidth;
            var _state = this.state,
                commentsLoaded = _state.commentsLoaded,
                minutesUntilClose = _state.minutesUntilClose,
                hasFetchedServerTime = _state.hasFetchedServerTime;


            if (!hasFetchedServerTime && !commentsAlwaysOpen) {
                return null;
            }

            if (minutesUntilClose > 0 || commentsAlwaysOpen) {
                return _react2.default.createElement(_FacebookComments2.default, {
                    loadFbSdk: function loadFbSdk() {
                        return _this3.loadFbSdk(_this3.props.lang);
                    },
                    commentsAlwaysOpen: commentsAlwaysOpen,
                    minutesLeftWhenWarningDisplayed: minutesLeftWhenWarningDisplayed,
                    minutesUntilClose: minutesUntilClose,
                    buttonText: buttonText,
                    url: url,
                    numPosts: numPosts,
                    commentsLoaded: commentsLoaded,
                    theme: theme,
                    widgetWidth: widgetWidth
                });
            }
            return _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    'h2',
                    { className: theme['comments-closed-heading'] },
                    commentsClosedHeading
                ),
                _react2.default.createElement(
                    'p',
                    { className: theme['comments-closed-text'] },
                    commentsClosedText
                )
            );
        }
    }]);

    return FbComments;
}(_react.Component);

FbComments.propTypes = {
    appId: _propTypes2.default.string.isRequired,
    buttonText: _propTypes2.default.string,
    commentsClosedText: _propTypes2.default.string,
    commentsClosedHeading: _propTypes2.default.string,
    commentsOpenHour: _propTypes2.default.number,
    commentsCloseHour: _propTypes2.default.number,
    commentsAlwaysOpen: _propTypes2.default.bool,
    minutesLeftWhenWarningDisplayed: _propTypes2.default.number,
    cookie: _propTypes2.default.string,
    lang: _propTypes2.default.string,
    numPosts: _propTypes2.default.string,
    pollServerTimeInterval: _propTypes2.default.number,
    url: _propTypes2.default.string.isRequired,
    serverTimeEndpoint: _propTypes2.default.string.isRequired,
    theme: _propTypes2.default.shape({
        'comments-closed-heading': _propTypes2.default.string,
        'comments-closed-text': _propTypes2.default.string,
        'load-comments': _propTypes2.default.string
    }).isRequired,
    xfbml: _propTypes2.default.string,
    version: _propTypes2.default.string,
    widgetWidth: _propTypes2.default.string
};
FbComments.defaultProps = {
    buttonText: 'Last kommentarer',
    commentsClosedHeading: 'Kommentarfeltet er nå stengt',
    commentsClosedText: 'Kommentarfeltet er nå stengt og åpner igjen kl. 07.00. Velkommen tilbake da! VGs journalister og moderatorer overvåker denne debatten kontinuerlig mellom kl. 07 og 24.',
    commentsAlwaysOpen: false,
    commentsOpenHour: 7,
    commentsCloseHour: 24,
    cookie: 'true',
    lang: 'nb_NO',
    minutesLeftWhenWarningDisplayed: 15,
    pollServerTimeInterval: 5 * 60 * 1000, // ms
    numPosts: '10',
    serverTimeEndpoint: 'https://api.vg.no/current-time',
    version: 'v2.5',
    widgetWidth: undefined,
    xfbml: 'true'
};
exports.default = (0, _themeProvider.themer)('@vg/fb-comments')(FbComments);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/fb-comments/lib/cjs/index.js
 ** module id = 310
 ** module chunks = 1
 **/